import { Routes } from "@angular/router";
import { OcrQuotationRoutePaths } from "./ocr-quotation-route-paths";
import { loadTranslationResolver } from "@app/kernel/translations/resolvers/load-translations.resolver";
import { TRANSLATION_PATHS } from "@app/shared/general/translation/constants/translation.constant";
import { ocrQuotationResolver } from "./resolvers/ocr-quotation.resolver";

export const ocrQuotationRoutes: Routes = [
  {
    path: "",
    loadComponent: () => import("./pages/list-ocr-quotation/list-ocr-quotation.component").then(c => c.ListOcrQuotationComponent),
    resolve: {
      translation: loadTranslationResolver([TRANSLATION_PATHS.OCR_QUOTATION, TRANSLATION_PATHS.VEHICLE_INFO]),
    },
  },
  {
    path: OcrQuotationRoutePaths.CREATE,
    loadComponent: () => import("./pages/create-ocr-quotation/create-ocr-quotation.component").then(c => c.CreateOcrQuotationComponent),
    resolve: {
      translation: loadTranslationResolver([
        TRANSLATION_PATHS.OCR_QUOTATION,
        TRANSLATION_PATHS.FEATURES,
        TRANSLATION_PATHS.FUEL_TYPE,
        TRANSLATION_PATHS.TECHNICAL_DATA,
        TRANSLATION_PATHS.VEHICLE_INFO,
      ]),
    },
  },
  {
    path: OcrQuotationRoutePaths.UPDATE,
    loadComponent: () => import("./pages/update-ocr-quotation/update-ocr-quotation.component").then(c => c.UpdateOcrQuotationComponent),
    resolve: {
      ocrQuotation: ocrQuotationResolver,
      translation: loadTranslationResolver([
        TRANSLATION_PATHS.OCR_QUOTATION,
        TRANSLATION_PATHS.FEATURES,
        TRANSLATION_PATHS.FUEL_TYPE,
        TRANSLATION_PATHS.TECHNICAL_DATA,
        TRANSLATION_PATHS.VEHICLE_INFO,
      ]),
    },
  },
];
